// extracted by mini-css-extract-plugin
export default {"info":"_2JWu","link":"YOZd"};